export const myProjects = [
  // ==================
  //  Html&css project
  // ==================
  {
    all: "all",
    projectTitle: "Html&css project",
    category: "CSS",
    imgPath: "./images/kumo.png",
    url : "https://michealsoliman.github.io/Kumo/",
    urlGithub: "https://github.com/MichealSoliman/Kumo",
    subtitle: "Kumo website using HTML CSS only"
  },
  {
    all: "all",
    projectTitle: "Html&css project",
    category: "CSS",
    imgPath: "./images/julia.png",
    url : "https://michealsoliman.github.io/juila/",
    urlGithub: "https://github.com/MichealSoliman/juila",
    subtitle: "portfolio website using HTML CSS only"

  },

  // ==================
  //  Bootstrap project
  // ==================

  {
    all: "all",
    projectTitle: "Bootstrap project",
    category: "Bootstrap",
    imgPath: "./images/fashionColl.png",
    url : "https://michealsoliman.github.io/Fashion-Bootstrap/",
    urlGithub: "https://github.com/MichealSoliman/Fashion-Bootstrap",
    subtitle: "Fashion website using HTML CSS BOOTSTRAP"

  },
  {
    all: "all",
    projectTitle: "Bootstrap project",
    category: "Bootstrap",
    imgPath: "./images/CakesBakery.png",
    url : "https://michealsoliman.github.io/Cakes-Bakery/",
    urlGithub: "https://github.com/MichealSoliman/Cakes-Bakery",
    subtitle: "Bakery website using HTML CSS BOOTSTRAP"
  },

  // ==================
  //  JavaScript project
  // ==================

  {
    all: "all",
    projectTitle: "JavaScript project",
    category: "JavaScript",
    imgPath: "./images/Riyadh-Shipping.png",
    url : "https://riyadh-shipping.vercel.app/",
    urlGithub: "https://github.com/MichealSoliman/Riyadh-Shipping",
    subtitle: "International Shipping Website Design – Riyadh Logistics Made Easy. "
  },
  {
    all: "all",
    projectTitle: "JavaScript project",
    category: "JavaScript",
    imgPath: "./images/fire-fighting.png",
    url : "https://fire-fighting-six.vercel.app/",
    urlGithub: "https://github.com/MichealSoliman/fire-fighting",
    subtitle: "Fire protection website design for safety and emergency solutions"
  },
  {
    all: "all",
    projectTitle: "JavaScript project",
    category: "JavaScript",
    imgPath: "./images/carousel-1.jpg",
    url : "https://air-cool-tau.vercel.app/",
    urlGithub: "https://github.com/MichealSoliman/Air-cool",
    subtitle: "Reliable AC Installation, Maintenance & Repair Services "
  },

  // ==================
  //  React.js project
  // ==================

  {
    all: "all",
    projectTitle: "React.js project",
    category: "React.js",
    imgPath: "./images/acdemia.png",
    url : "https://reactbroject-9ffa6.firebaseapp.com/",
    urlGithub: "https://github.com/MichealSoliman/ReactBroject",
    subtitle: "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk"
  },
  {
    all: "all",
    projectTitle: "React.js project",
    category: "React.js",
    imgPath: "./images/fashion (2).png",
    url : "https://fashion-steel-eta.vercel.app/",
    urlGithub: "https://github.com/MichealSoliman/Fashion",
    subtitle: "A user-friendly fashion website featuring a wide collection of trendy outfits."
  },
 
];
